import { render, staticRenderFns } from "./CurrentRegistration.vue?vue&type=template&id=519da0b6&scoped=true"
import script from "./CurrentRegistration.vue?vue&type=script&lang=js"
export * from "./CurrentRegistration.vue?vue&type=script&lang=js"
import style0 from "./CurrentRegistration.vue?vue&type=style&index=0&id=519da0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519da0b6",
  null
  
)

export default component.exports